<!-- <carousel (activeSlideChange)="onNavCarousel($event)" [interval]="false" [showIndicators]="true" [activeSlide]="currentSlide" [noWrap]="true">
  <slide *ngFor="let image of images; let i = index">
    <img [src]="image.url_large" alt="image slide" class="slide-img">
  </slide>
</carousel> -->
<ng-template #konva>
  <!-- <ng-container *ngIf="container === 'konva-stage'"> -->
  <div class="konva-container" [style.height]="stageHeight + 'px;'">
    <div id="konva-stage"></div>
    <div
      class="loading"
      style="position: absolute; top: 30%; left: 40%"
      *ngIf="isLoadingImage"
    >
      <img src="assets/images/grid.svg" />
    </div>
    <div class="action-btn tool-btn">
      <button class="btn btn-sm btn-light" (click)="resetKonva()">
        {{ "Reset image position" | translate }}
      </button>
      <button class="btn btn-sm btn-light" (click)="showCarousel()">
        <i class="icon-expand-full"></i>
      </button>
    </div>
    <div class="action-btn navigation-btn">
      <button
        class="btn btn-sm btn-circle btn-prev btn-light"
        (click)="onClickNav('prev')"
      >
        <i class="icon-arrow-left"></i>
      </button>
      <button
        class="btn btn-sm btn-circle btn-next btn-light"
        (click)="onClickNav('next')"
      >
        <i class="icon-arrow-right"></i>
      </button>
    </div>
    <div class="toolbar">
      <div class="left-toolbar">
        <button class="btn btn-sm btn-primary ml-1" routerLink="../attachment">
          {{ "Upload Images" | translate }}
        </button>
      </div>
      <div class="right-toolbar">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="!activeTool"
            (click)="activateTool()"
          >
            <i class="icon-pointer"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'text'"
            (click)="activateTool('text')"
          >
            <i class="icon-text"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'rectangle'"
            (click)="activateTool('rectangle')"
          >
            <i class="icon-box"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'circle'"
            (click)="activateTool('circle')"
          >
            <i class="icon-circle"></i>
          </button>
        </div>
        <button
          class="btn btn-sm btn-primary ml-1 konva-clear-btn"
          (click)="onClickClearBtn()"
        >
          {{ "Clear All" | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- </ng-container> -->
  <ng-container *ngTemplateOutlet="annotationFormView"></ng-container>
</ng-template>
<ng-template #konva2>
  <div class="konva-container-2 expanded" [style.height]="stageHeight + 'px;'">
    <div
      id="konva-stage2"
      class="d-flex align-items-center justify-content-center"
    ></div>
    <div
      class="loading"
      style="position: absolute; top: 42%; left: 48%"
      *ngIf="isLoadingImage"
    >
      <img src="assets/images/grid.svg" />
    </div>
    <div class="action-btn tool-btn">
      <button class="btn btn-sm btn-light" (click)="resetKonva('konva-stage2')">
        {{ "Reset image position" | translate }}
      </button>
    </div>
    <div class="action-btn navigation-btn">
      <button
        class="btn btn-sm btn-circle btn-prev btn-light"
        (click)="onClickNav('prev')"
      >
        <i class="icon-arrow-left"></i>
      </button>
      <button
        class="btn btn-sm btn-circle btn-next btn-light"
        (click)="onClickNav('next')"
      >
        <i class="icon-arrow-right"></i>
      </button>
    </div>
    <div class="toolbar">
      <div class="left-toolbar">
        <button class="btn btn-sm btn-primary ml-1" routerLink="../attachment">
          {{ "Upload Images" | translate }}
        </button>
      </div>
      <div class="right-toolbar">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="!activeTool"
            (click)="activateTool()"
          >
            <i class="icon-pointer"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'text'"
            (click)="activateTool('text')"
          >
            <i class="icon-text"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'rectangle'"
            (click)="activateTool('rectangle')"
          >
            <i class="icon-box"></i>
          </button>
          <button
            class="btn btn-sm btn-secondary"
            [class.active]="activeTool === 'circle'"
            (click)="activateTool('circle')"
          >
            <i class="icon-circle"></i>
          </button>
        </div>
        <button class="btn btn-sm btn-primary ml-1" (click)="onClickClearBtn()">
          {{ "Clear All" | translate }}
        </button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="annotationFormView"></ng-container>
  </div>
</ng-template>
<ng-template #videoContainer>
  <div
    class="video-container"
    [style]="'min-height: calc(' + stageHeight + 'px + 35.67px);'"
    *ngIf="isVideo"
  >
    <vg-player>
      <video
        [vgMedia]="$any(media)"
        #media
        id="singleVideo"
        preload="auto"
        controls
      >
        <source [src]="videoUrl" type="video/mp4" />
      </video>
    </vg-player>
    <div class="action-btn navigation-btn">
      <button
        class="btn btn-sm btn-circle btn-prev btn-light"
        (click)="onClickNav('prev')"
      >
        <i class="icon-arrow-left"></i>
      </button>
      <button
        class="btn btn-sm btn-circle btn-next btn-light"
        (click)="onClickNav('next')"
      >
        <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>
</ng-template>
<ng-container
  *ngTemplateOutlet="videoUrl.length === 0 ? konva : videoContainer"
></ng-container>
<div class="cdk-virtual-scroll-data-source">
  <cdk-virtual-scroll-viewport
    orientation="horizontal"
    itemSize="80"
    class="viewport"
  >
    <div
      *cdkVirtualFor="let image of images; let i = index"
      id="{{ 'thumbnail-' + i }}"
      class="item"
      [class.border]="i === currentSlide"
      [class.border-primary]="i === currentSlide"
      (click)="onClickThumbnail(i)"
    >
      <img
        *ngIf="image.file_type === 'images'"
        [src]="
          image.file_type === 'images' || image.file_type === 'image'
            ? image.url_small || image.url
            : 'assets/images/video-thumb_bk.png'
        "
        style="width: 100%"
      />

      <div *ngIf="image.file_type === 'videos'" class="img-overlay">
        <video [src]="image.url"></video>
      </div>

      <div class="btn-container">
        <a (click)="showCarousel(i)"><i class="icon-clusters"></i></a>
        <a [href]="image.url" download target="_blank"
          ><i class="icon-download"></i
        ></a>
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
<ng-template #carouselModal>
  <div class="carousel-container">
    <div class="btn-container px-4">
      <button
        class="btn-close btn btn-sm btn-primary transparent"
        (click)="hideCarousel()"
      >
        {{ "Close" | translate }}
      </button>
    </div>
    <carousel
      (activeSlideChange)="onNavCarousel($event)"
      [interval]="0"
      [showIndicators]="true"
      [activeSlide]="currentSlide"
      [noWrap]="true"
    >
      <slide *ngFor="let image of images; let i = index; trackById">
        <img
          [src]="image.url_large || image.url"
          alt="image slide"
          style="display: block; width: 70vw"
        />
      </slide>
    </carousel>
  </div>
</ng-template>
<ng-template #annotationFormView>
  <div
    class="content content-form"
    *ngIf="isAnnotationFormOn || isAnnotationFormOnUpdate"
    [@annotationForm]
  >
    <div class="form-container">
      <form [formGroup]="annotationForm" (ngSubmit)="onSubmitForm()">
        <div class="row no-gutters">
          <div class="col-6">
            <div class="annot-thumbnail" style="background-color: #eeeeee">
              <img
                class="rounded"
                [src]="
                  konvaScreenshot
                    ? konvaScreenshot
                    : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                "
                style="width: 100%; height: inherit"
              />
              <button
                class="btn btn-sm btn-secondary btn-screenshot"
                (click)="screenshotKonva()"
                type="button"
              >
                {{ "Screenshot" | translate }}
              </button>
            </div>
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  formControlName="area_size"
                  type="text"
                  class="form-control"
                  [value]="annotationForm?.get('area_size').value"
                  placeholder="{{ 'Area Size' | translate }}"
                />
                <div class="input-group-append" style="height: 2em">
                  <span class="input-group-text">{{ "m²" }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group severity">
              <label>{{ "Severity" | translate }}</label>
              <div class="d-block">
                <span *ngFor="let severity of severityList; trackById">
                  <input
                    formControlName="severity_type"
                    type="radio"
                    [id]="severity.id"
                    [value]="severity.id"
                  />
                  <label
                    [for]="severity.id"
                    class="btn btn-sm btn-circle"
                    [style.backgroundColor]="severity.description"
                    [class.active]="
                      annotationForm.get('severity_type').value === severity.id
                    "
                  >
                  </label>
                </span>
              </div>
              <small
                class="form-text text-danger"
                *ngIf="
                  (annotationForm.controls.severity_type.touched ||
                    submitted) &&
                  annotationForm.controls.severity_type.errors?.required
                "
                >{{ "* Severity is required" | translate }}</small
              >
            </div>
            <div class="form-group">
              <label>{{ "Details" | translate }}</label>
              <input
                formControlName="name"
                type="text"
                class="form-control"
                placeholder="{{ 'Annotation Name' | translate }}"
              />
              <small
                class="form-text text-danger"
                *ngIf="
                  (annotationForm.controls.name.touched || submitted) &&
                  annotationForm.controls.name.errors?.required
                "
                >{{ "* Annotation name is required" | translate }}</small
              >
            </div>
            <div class="form-group">
              <textarea
                formControlName="description"
                class="form-control"
                placeholder="{{ 'Description' | translate }}"
              ></textarea>
              <small
                class="form-text text-danger"
                *ngIf="
                  (annotationForm.controls.description.touched || submitted) &&
                  annotationForm.controls.description.errors?.required
                "
                >{{ "* Annotation description is required" | translate }}</small
              >
            </div>
            <div class="form-group">
              <select formControlName="location_component" class="form-control">
                <option value="" disabled selected>
                  {{ "Select location component" | translate }}
                </option>
                <option
                  *ngFor="let component of locationComponentList; trackById"
                  [value]="component.id"
                >
                  {{ component.name | translate | titlecase }}
                </option>
              </select>
              <small
                class="form-text text-danger"
                *ngIf="
                  (annotationForm.controls.location_component.touched ||
                    submitted) &&
                  annotationForm.controls.location_component.errors?.required
                "
                >{{ "* Location component is required" | translate }}</small
              >
            </div>
            <div class="form-group">
              <select formControlName="annotation_type" class="form-control">
                <option value="" disabled selected>
                  {{ "Select defect type" | translate }}
                </option>
                <option
                  *ngFor="let defectType of defectTypes; trackById"
                  [value]="defectType.id"
                >
                  {{ defectType.name | translate | titlecase }}
                </option>
              </select>
              <small
                class="form-text text-danger"
                *ngIf="
                  (annotationForm.controls.annotation_type.touched ||
                    submitted) &&
                  annotationForm.controls.annotation_type.errors?.required
                "
                >{{ "* Defect type is required" | translate }}</small
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row no-gutters">
            <div class="col mr-2">
              <button
                class="btn btn-secondary btn-sm btn-block"
                type="button"
                (click)="resetAnnotationForm()"
              >
                {{ "Cancel" | translate }}
              </button>
            </div>
            <div class="col">
              <button class="btn btn-primary btn-sm btn-block" type="submit">
                {{ isAnnotationFormOnUpdate ? "Update" : ("Save" | translate) }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
